import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/shared/Button.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import Modal from 'components/shared/Modal';
import { useI18n } from 'hooks/useI18n';
import { withTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { removeQueryParamsFromRouter } from 'utils/router';
import { OFFER_CANCELLED_PARAM } from './JobOfferURLNonExistModal.constants';
import {
  StyledActions,
  StyledIcon,
  StyledText,
  StyledTitle
} from './JobOfferURLNonExistModal.styled';

const JobOfferURLNonExistModal: React.FC = () => {
  const router = useRouter();
  const { t } = useI18n('job-offer-url-non-exist-modal');
  const [isModalOpen, setIsModalOpen] = useState(false);

  function isOfferCancelled(params: URLSearchParams): boolean {
    return (
      params.get(OFFER_CANCELLED_PARAM) !== null &&
      params.get(OFFER_CANCELLED_PARAM) !== ''
    );
  }
  function closeOfferCancelledModal(): void {
    setIsModalOpen(false);
  }
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    if (isOfferCancelled(urlSearchParams)) {
      setIsModalOpen(true);

      setTimeout(() => {
        removeQueryParamsFromRouter(router, [OFFER_CANCELLED_PARAM]);
      }, 500);
    }
  }, []);

  return (
    <ReactModal
      isOpen={isModalOpen}
      contentLabel={t('job_offer_url_non_exist_modal.title')}
    >
      <Modal>
        <StyledIcon>
          <FontAwesomeIcon icon={faTriangleExclamation} />
        </StyledIcon>
        <StyledTitle>{t('job_offer_url_non_exist_modal.title')}</StyledTitle>
        <StyledText>
          <HtmlTrans
            ns="job-offer-url-non-exist-modal"
            i18nKey="job_offer_url_non_exist_modal.desc"
            components={{
              email: <a href="mailto:support@getmanfred.com" />
            }}
          />
        </StyledText>

        <StyledActions>
          <Button
            variant="primary"
            id="modal-not-go-button"
            aria-label={t('job_offer_url_non_exist_modal.CTA')}
            sizes="md"
            onClick={() => {
              closeOfferCancelledModal();
            }}
          >
            <span aria-hidden="true">
              {t('job_offer_url_non_exist_modal.CTA')}
            </span>
          </Button>
        </StyledActions>
      </Modal>
    </ReactModal>
  );
};

export default withTranslation(['job-offer-url-non-exist-modal'])(
  JobOfferURLNonExistModal
);
